import {
  handleClosedOnboardingRequest,
  handleClosedOnboardingError,
} from './interceptors';

import api from './api';

export * from './types';

export const DefaultApi = api(
  `${process.env.REACT_APP_ONBOARDING_API_URL}`,
  {}
);

export const DefaultApiBKO = api(
  `${process.env.REACT_APP_GET_TERMS_BKO_API}`,
  {}
);

export const ClosedOnboardingApi = api(
  `${process.env.REACT_APP_ONBOARDING_API_URL}`,
  {}
);

ClosedOnboardingApi.interceptors.request.use(
  handleClosedOnboardingRequest,
  (error) => Promise.reject(error)
);

ClosedOnboardingApi.interceptors.response.use(
  (response) => response,
  handleClosedOnboardingError
);
